import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../Header";
import { isWebView, Toast, Userlogin } from "../Utils/general-function";
import useRazorpayPayment from "./useRazorpayPayment";
import DataTable from "react-data-table-component";

export const PaymentSucc = () => {
  const { status, handlePayment, setStatus } = useRazorpayPayment();
  console.log("status", status);

  const navigate = useNavigate();
  const [inputVal, setInput] = useState({
    balance: 0,
  });

  //METHOD
  useEffect(() => {
    if (!Userlogin()) navigate("/Login");
  }, []);

  const onInputChange = (e) => {
    const { name, value } = e.target;
    setInput((preVal) => ({ ...preVal, [name]: value }));
    let latestVal = {
      ...inputVal,
      [name]: value,
    };
  };

  const rupeeFormat = (rs) =>
    rs.toLocaleString("en-IN", {
      maximumFractionDigits: 0,
      style: "currency",
      currency: "INR",
    });

  // DATA TABLE
  const [filterText, setFilterText] = useState("");

  const data = [
    { id: 1, name: "Car 1", price: 500000 },
    { id: 2, name: "Car 2", price: 700000 },
  ];

  const columns = [
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Price",
      selector: (row) => row.price,
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => <button onClick={() => handleClick(row)}>View</button>,
    },
  ];

  const handleClick = (row) => {
    console.log("Clicked:", row);
  };

  const filteredData = data.filter(
    (item) =>
      item.name?.toLowerCase().includes(filterText.toLowerCase()) ||
      item.price?.toString().includes(filterText.toLowerCase()),
  );
  const customStyles = {
    headRow: {
      style: {
        backgroundColor: "red",
        color: "white",
        fontSize: "16px",
        fontWeight: "bold",
      },
    },
    rows: {
      style: {
        minHeight: "60px",
        fontSize: "14px",
      },
    },
    cells: {
      style: {
        paddingLeft: "16px",
        paddingRight: "16px",
      },
    },
  };

  console.log("status", status);
  useEffect(() => {
    // if (isWebView()) {

    // }
    const paymentStatus = localStorage.getItem("paymentStatus");
    if (paymentStatus === "pending") {
      setStatus("pending");
    }
  }, []);
  return (
    <>
      <Header />
      <div className="page-space">
        <div className="text-center">
          <h2 className="page-title">Payment Success</h2>
        </div>

        {/* input */}
        <div
          className="text-center bg-white P-4 d-flex justify-content-between align-items-center gap-3"
          style={{
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
            padding: "18px",
          }}
        >
          <h3>Balance: {rupeeFormat(inputVal.balance)}</h3>
          <button
            type="submit"
            className="submitbtn"
            onClick={() => {
              if (status === "pending") {
                Toast(true, "Payment  completed.", "");
                localStorage.clear("paymentStatus");
                setStatus("idle");
              } else {
                handlePayment({ amount: 500 });
              }
            }}
          >
            {/* Add Wallet */}
            {status === "pending" ? "Retry" : "Pay Now"}
          </button>
        </div>

        <button
          type="submit"
          className="submitbtn mt-2"
          onClick={() => {
            window.location.href = "https://m.carthi.in/#/mywallet";
          }}
        >
          {/* Add Wallet */}
          Pay on Safari
        </button>
        <div className="mt-3 text-center">
          {/* UI States */}
          {status === "loading" && <p>⏳ Processing...</p>}

          {status === "verifying" && <p>🔐 Verifying...</p>}
          {status === "success" && <p>✅ Payment Success</p>}
          {status === "failed" && <p>❌ Payment Failed</p>}
          {status === "cancelled" && <p>⚠️ Payment Cancelled</p>}
          {status === "pending" && <p>Retry </p>}
        </div>
      </div>

      <>
        <input
          type="text"
          placeholder="Search..."
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
        />

        <DataTable
          columns={columns}
          data={filteredData}
          pagination
          highlightOnHover
          responsive
          striped
          customStyles={customStyles}
          style={{ maxHeight: "10px" }}
          onRowClicked={(row) => console.log("Row clicked:", row)}
        />
      </>
    </>
  );
};
